import { NotificationManager } from "components/common/react-notifications";
import { ADD_ADVOCATE_FAILED, ADD_ADVOCATE_SUCCESS, CLEAR_ADVOCATE_MESSAGES, DOWNLOAD_CONTRACT, DOWNLOAD_CONTRACT_FAILED, DOWNLOAD_CONTRACT_SUCCESS, GET_ADVOCATES_LIST, GET_ADVOCATES_LIST_FAILED, GET_ADVOCATES_LIST_SUCCESS, SEND_CONTRACT, SEND_CONTRACT_FAILED, SEND_CONTRACT_SUCCESS, UPDATE_ADVOCATE_FAILED, UPDATE_ADVOCATE_STATUS_FAILED, UPDATE_ADVOCATE_STATUS_SUCCESS, UPDATE_ADVOCATE_SUCCESS, UPLOAD_ADVOCATE_DOC, UPLOAD_ADVOCATE_DOC_FAILED, UPLOAD_ADVOCATE_DOC_SUCCESS, VIEW_CONTRACT_FAILED, VIEW_CONTRACT_SUCCESS } from "./actions";

let initialState = {
  data: [],
  message: "",
  loading: false,
  count: null,
  updateMessage: ""
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ADVOCATES_LIST:
      return { ...state, loading: true };
    case GET_ADVOCATES_LIST_SUCCESS:
      return { ...state, data: action.data, message: "", loading: false };
    case GET_ADVOCATES_LIST_FAILED:
      return { ...state, data: [], message: action.message, loading: false };

    case ADD_ADVOCATE_SUCCESS:
      NotificationManager.success("", action.message || "Advocate Added Successfully!", 3000, null, null, "filled");
      return { ...state, data: action.data, message: "Advocate Added Successfully!", loading: false };
    case ADD_ADVOCATE_FAILED:
      NotificationManager.error("", action.message || "Failed to add Advocate!", 3000, null, null, "filled");
      return { ...state, data: [], message: "Failed to add Advocate!", loading: false };
    case UPDATE_ADVOCATE_SUCCESS: {
      const successMsg = action.message || "Advocate Details Updated Successfully!";
      NotificationManager.success("", successMsg, 3000, null, null, "filled");
      return { ...state, data: action.data, updateMessage: successMsg };
    }

    case UPDATE_ADVOCATE_FAILED:
      NotificationManager.error("", action.message || "Failed to Update Advocate Details !", 3000, null, null, "filled");
      return { ...state, updateMessage: "Failed to Update Advocate Details !" };
    case UPDATE_ADVOCATE_STATUS_SUCCESS:
      NotificationManager.success("", action.message || "Status Updated Successfully!", 3000, null, null, "filled");
      return { ...state, updateMessage: "Status Updated Successfully !", loading: false };
    case UPDATE_ADVOCATE_STATUS_FAILED:
      NotificationManager.error("", action.message || "Failed to Update Status !", 3000, null, null, "filled");
      return { ...state, updateMessage: "Failed to Update Status !", loading: false };

    case UPLOAD_ADVOCATE_DOC:
      return { ...state, loading: true };
    case UPLOAD_ADVOCATE_DOC_SUCCESS:
      NotificationManager.success("", action.message || "Document Uploaded Successfully !", 3000, null, null, "filled");
      return { ...state, updateMessage: "Document Uploaded Successfully !", loading: false };
    case UPLOAD_ADVOCATE_DOC_FAILED:
      NotificationManager.error("", action.message || "Failed to Upload Document !", 3000, null, null, "filled");
      return { ...state, updateMessage: "Failed to Upload Document !", loading: false };

    case VIEW_CONTRACT_SUCCESS:
      NotificationManager.success("", action.message || "Contract Open Successfully !", 3000, null, null, "filled");
      return { ...state, data: action.data, updateMessage: "Contract Open Successfully !", loading: false };
    case VIEW_CONTRACT_FAILED:
      NotificationManager.error("", action.message || "Failed to open Contract !", 3000, null, null, "filled");
      return { ...state, updateMessage: "Failed to open Contract !", loading: false };

    case SEND_CONTRACT:
      return { ...state, loading: true };
    case SEND_CONTRACT_SUCCESS:
      NotificationManager.success("", action.message, 3000, null, null, "filled");
      return { ...state, updateMessage: "Contract Sent Successfully !", loading: false };
    case SEND_CONTRACT_FAILED:
      NotificationManager.error("", action.message || "Failed to send Contract !", 3000, null, null, "filled");
      return { ...state, updateMessage: "Failed to send Contract !", message: action.message, loading: false };
    case DOWNLOAD_CONTRACT:
      return { ...state, loading: true };
    case DOWNLOAD_CONTRACT_SUCCESS:
      NotificationManager.success("", action.message, 3000, null, null, "filled");
      return { ...state, updateMessage: "Contract Open Successfully !", loading: false };
    case DOWNLOAD_CONTRACT_FAILED:
      NotificationManager.error("", action.message || "Failed to open Contract !", 3000, null, null, "filled");
      return { ...state, updateMessage: "Failed to open Contract !", loading: false };

    case CLEAR_ADVOCATE_MESSAGES:
      return { ...state, message: "",  updateMessage: "", error: ""};

    default:
      return { ...state };
  }
}
